<template>
  <section class="mission-group">
    <header><h2>{{ title }}</h2><p>{{ subtitle }}</p></header>
    <div class="mission-list">
      <article v-for="mission in missions" :key="mission.id" :class="{ done: mission.done }">
        <div class="mission-icon">{{ mission.claimed ? '✓' : mission.done ? '🎁' : '✦' }}</div>
        <div class="mission-body">
          <strong>{{ label(mission.id, 0) }}</strong>
          <small>{{ label(mission.id, 1) }}</small>
          <div class="mission-progress"><i :style="{ width: `${progress(mission)}%` }"></i></div>
          <em>{{ display(mission.progress, mission) }} / {{ display(mission.target, mission) }}</em>
        </div>
        <div class="mission-reward"><span>🪙 {{ mission.coin }}</span><span>✨ {{ mission.xp }} XP</span></div>
        <button type="button" :disabled="!mission.done || mission.claimed || claiming === mission.id" @click="$emit('claim', mission.id)">
          {{ mission.claimed ? 'รับแล้ว' : claiming === mission.id ? 'กำลังรับ...' : mission.done ? 'รับรางวัล' : 'ยังไม่ครบ' }}
        </button>
      </article>
    </div>
  </section>
</template>

<script>
const labels = {
  m_checkin: ['เช็กอินให้อาหาร', 'ให้อาหารคู่หูวันนี้'],
  m_deposit300: ['ฝากสะสมครบ 300 บาท', 'นับยอดฝากสำเร็จรวมวันนี้'],
  w_checkin5: ['เช็กอินครบ 5 วัน', 'ให้อาหารอย่างน้อย 5 วันในสัปดาห์'],
  w_depositdays5: ['ฝากเงินครบ 5 วัน', 'มียอดฝากสำเร็จอย่างน้อย 5 วัน'],
  w_deposit3000: ['ฝากสะสมครบ 3,000 บาท', 'นับยอดฝากสำเร็จรวมทั้งสัปดาห์']
}

export default {
  name: 'QilinMissionGroup',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    missions: { type: Array, required: true },
    claiming: { type: String, default: '' }
  },
  methods: {
    label (id, index) { return labels[id] ? labels[id][index] : id },
    progress (mission) { return Math.min(100, Math.round(mission.progress / mission.target * 100)) },
    display (value, mission) {
      const isAmount = mission.id === 'm_deposit300' || mission.id === 'w_deposit3000'
      return isAmount ? `${Number(value).toLocaleString()} บาท` : `${value} วัน`
    }
  }
}
</script>

<style scoped>
.mission-group { margin-top: 14px; padding: 19px; border: 1px solid rgba(255,255,255,.09); border-radius: 23px; background: rgba(27,7,43,.86); }
header h2 { margin: 0; font-size: 19px; }
header p { margin: 2px 0 13px; color: rgba(255,255,255,.46); font-size: 11px; }
.mission-list { display: grid; gap: 8px; }
article { display: grid; grid-template-columns: 42px minmax(0,1fr) auto 95px; align-items: center; gap: 12px; padding: 13px; border: 1px solid rgba(255,255,255,.06); border-radius: 16px; background: rgba(255,255,255,.04); }
article.done { border-color: rgba(182,92,240,.21); }
.mission-icon { display: grid; width: 42px; height: 42px; place-items: center; border-radius: 13px; background: rgba(182,92,240,.1); color: #78e7ca; }
.mission-body strong, .mission-body small { display: block; }
.mission-body strong { font-size: 13px; }
.mission-body small { color: rgba(255,255,255,.46); font-size: 10px; }
.mission-progress { height: 6px; overflow: hidden; margin-top: 7px; border-radius: 99px; background: rgba(0,0,0,.32); }
.mission-progress i { display: block; height: 100%; border-radius: inherit; background: linear-gradient(90deg,#48d6b3,#fbc844); }
.mission-body em { display: block; margin-top: 3px; color: rgba(255,255,255,.4); font-size: 9px; font-style: normal; }
.mission-reward { display: flex; gap: 5px; flex-direction: column; }
.mission-reward span { padding: 3px 7px; border-radius: 7px; background: rgba(251,200,68,.09); color: #ffe182; font-size: 9px; white-space: nowrap; }
button { min-height: 38px; border: 0; border-radius: 11px; background: linear-gradient(135deg,#ffd85d,#f39a32); color: #181327; font-family: inherit; font-size: 11px; font-weight: 900; }
button:disabled { background: rgba(255,255,255,.08); color: rgba(255,255,255,.38); }
@media (max-width: 700px) {
  article { grid-template-columns: 38px minmax(0,1fr); }
  .mission-reward { grid-column: 2; flex-direction: row; }
  button { grid-column: 1 / -1; }
}
</style>
